import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { useNavigate, useRouteError } from "react-router-dom";

interface ErrorWithStatus {
  status: number;
}

const hasStatus = (error: unknown): error is ErrorWithStatus => {
  return typeof (error as ErrorWithStatus).status === "number";
};

export const ErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    if (import.meta.env.DEV) {
      console.error(error);
    } else if ((hasStatus(error) && error.status !== 404) || !hasStatus(error)) {
      Sentry.captureException(error);
    }
  }, [error]);

  useEffect(() => {
    if (hasStatus(error) && error.status === 404) {
      navigate("/homePage");
    }
  }, [error]);

  return (
    <Stack justifyContent="center" alignItems="center" flexGrow={1}>
      <Typography variant="h1">Oops!</Typography>
      <Typography>Une erreur inattendue est survenue</Typography>
    </Stack>
  );
};

// biome-ignore lint/style/noDefaultExport: <explanation>
export default ErrorPage;
